module.exports = __webpack_public_path__ + "media/img/event/mit-stem-3ed2e4a1d7f24687a0b3c866886835bf.png";